import { spacings } from "@/assets/themes";
import { Block, Button, H2, Modal, Stepper } from "@/components";
import { STEPPER } from "@/components/Styles/variants";
import useJob from "@/modules/hooks/useJob";
import { usePutJobNbHours } from "@/modules/routes";
import { MAX_NB_HOURS, MIN_NB_HOURS } from "@/pages/categoryForms/constants";
import polyglot from "@/utils/polyglot";
import { useFormik } from "formik";
import { useEffect } from "react";

const EditNbHoursModal = ({ isOpen, onClose }) => {
  const { data } = useJob();
  const editJobNbHours = usePutJobNbHours({ id: data.id });

  useEffect(() => {
    if (editJobNbHours.isSuccess) {
      onClose();
    }
  }, [editJobNbHours.isSuccess]);

  const formik = useFormik({
    initialValues: {
      nb_hours: data.nb_hours,
    },
    onSubmit: (values) => {
      editJobNbHours.mutate({
        nb_hours: values.nb_hours,
      });
    },
  });

  return (
    <Modal.XSmall isOpen={isOpen} onClose={onClose}>
      <Modal.Item.Header isOpen={isOpen} onClose={onClose}>
        <H2>{polyglot.t("jobs.edit_nb_hours")}</H2>
      </Modal.Item.Header>
      <form onSubmit={formik.handleSubmit}>
        <Modal.Item.Wrapper>
          <Block marginTop={spacings.m} marginBottom={spacings.sm}>
            <Stepper
              size={STEPPER.SIZE.LARGE}
              value={formik.values.nb_hours}
              step={0.5}
              hint={polyglot.t("job.initial_nb_hours", {
                nb_hours: polyglot.toDuration(data.nb_hours || 0, {
                  isDuration: true,
                }),
              })}
              min={MIN_NB_HOURS}
              max={MAX_NB_HOURS}
              onChange={(value) => {
                formik.setFieldValue("nb_hours", value);
              }}
            >
              {polyglot.toDuration(formik.values.nb_hours || 0, {
                isDuration: true,
              })}
            </Stepper>
          </Block>
        </Modal.Item.Wrapper>
        <Modal.Item.Footer column>
          <Button.Large
            block
            type="submit"
            isLoading={editJobNbHours.isLoading}
          >
            {polyglot.t("common.save")}
          </Button.Large>
        </Modal.Item.Footer>
      </form>
    </Modal.XSmall>
  );
};

export default EditNbHoursModal;
